import { useMutation } from 'react-query';
import { saveProfile, Profile } from '@creditsights/api-ui-web';
// eslint-disable-next-line import/no-unresolved
import { creditsightsSyncDataSubject$, SyncDataSubject as CreditSightsSyncDataSubject } from '@creditsights/creditsights-web';
// eslint-disable-next-line import/no-unresolved
import { navbarSyncDataSubject$, SyncDataSubject as NavBarSyncDataSubject } from '@creditsights/navbar-web';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () =>
  useMutation<Profile, void, Partial<Profile>, void>((profile) => saveProfile(profile), {
    onSuccess: () => {
      creditsightsSyncDataSubject$.next(CreditSightsSyncDataSubject.USER_PROFILE);
      navbarSyncDataSubject$.next(NavBarSyncDataSubject.USER_PROFILE);
    },
  });
